import { useEffect, useMemo, useState } from "react"
import { Layout, Menu } from "antd"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import MENU from "./MenuJson"
import { filterMenuByAccess, findOpenKeys, findSelectedKeys, toAntdMenuItems } from "./filterMenu"
import AssetPath from "../AssetPath/AssetPath"
import "./SideNav.scss"

const { Sider } = Layout

const SideNav = () => {
  const [collapsed, setCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const userInfo = useSelector((state) => state.user.data)
  const appName = process.env.REACT_APP_APPNAME || "Device Manager"

  const filtered = useMemo(
    () => filterMenuByAccess(MENU, userInfo),
    [userInfo]
  )
  const items = useMemo(() => toAntdMenuItems(filtered), [filtered])
  const routeOpenKeys = useMemo(
    () => findOpenKeys(filtered, location.pathname),
    [filtered, location.pathname]
  )
  const selectedKeys = findSelectedKeys(filtered, location.pathname)
  const [openKeys, setOpenKeys] = useState(routeOpenKeys)

  useEffect(() => {
    setOpenKeys((prev) => [...new Set([...prev, ...routeOpenKeys])])
  }, [routeOpenKeys])

  useEffect(() => {
    const media = window.matchMedia("(max-width: 991px)")
    const sync = () => {
      setIsMobile(media.matches)
      setCollapsed(media.matches)
    }
    sync()
    media.addEventListener("change", sync)
    return () => media.removeEventListener("change", sync)
  }, [])

  const handleMenuClick = ({ key }) => {
    if (key.startsWith("/")) {
      navigate(key)
    }
  }

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      width={248}
      collapsedWidth={isMobile ? 0 : 72}
      breakpoint="lg"
      zeroWidthTriggerStyle={{ display: "none" }}
      className="app-sidenav"
      theme="dark"
    >
      <Link to="/" className="app-sidenav__brand">
        <img src={AssetPath.brand.appIcon} alt="" />
        {!collapsed ? (
          <span className="app-sidenav__brand-text">{appName}</span>
        ) : null}
      </Link>
      <Menu
        theme="dark"
        mode="inline"
        inlineIndent={16}
        items={items}
        selectedKeys={selectedKeys}
        {...(collapsed
          ? {}
          : { openKeys, onOpenChange: setOpenKeys })}
        onClick={handleMenuClick}
      />
    </Sider>
  )
}

export default SideNav
